export default __webpack_public_path__ + "static/media/drink3.1cff9d66.png";